'use strict';

var React = require('react');

var SvgPinMajor = function SvgPinMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.5 5v.5c0 .495.24.934.61 1.207.22.163.374.436.294.698l-.838 2.741a.5.5 0 0 1-.478.354h-.088a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5h-.088a.5.5 0 0 1-.479-.354l-.837-2.74c-.08-.263.074-.536.295-.7.37-.272.609-.711.609-1.206v-.5a1.5 1.5 0 0 0-1.5-1.5h-4a1.5 1.5 0 0 0-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 5v.5c0-.001 0-.001 0 0 .489.362 1.18 1.227.839 2.343l-.839 2.741a2 2 0 0 1-1.912 1.416h-.088v1h8v-1h-.088a2 2 0 0 1-1.913-1.416l-.838-2.74c-.34-1.117.35-1.982.838-2.343l.001-.001v-.5h-4zm0 .502zm-1.5-.002v-.5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v.5c0 .495-.24.934-.61 1.207-.22.163-.374.436-.294.698l.838 2.741a.5.5 0 0 0 .478.354h.088a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-8a1.5 1.5 0 0 1-1.5-1.5v-1a1.5 1.5 0 0 1 1.5-1.5h.088a.5.5 0 0 0 .478-.354l.838-2.74c.08-.263-.074-.536-.295-.7a1.498 1.498 0 0 1-.609-1.206z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.928 13.265a.75.75 0 0 1 .572-.265h1a.75.75 0 0 1 .74.873l-.5 3a.75.75 0 0 1-1.48 0l-.5-3a.75.75 0 0 1 .168-.608z"
  }));
};
SvgPinMajor.displayName = "PinMajor";

exports.SvgPinMajor = SvgPinMajor;
